module.exports = __webpack_public_path__ + "img/driver.0898c3f3.png";